import { useCallback, createElement } from 'react';
import sections from '../../../sections';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const renderSection = useCallback(key => createElement(sections[key].component), []);

    return [renderSection];
};
